export default __webpack_public_path__ + "static/media/edenred.194f9110.svg";